import { css } from '@emotion/react';

const containerStyles = css`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  align-items: center;
  justify-content: flex-start;
  padding: 80px 24px;
  background-color: #fcfbf9;
`;

const headingStyles = css`
  font-family: 'FlodeskSans', sans-serif;
  font-size: 48px;
  font-weight: 500;
  color: #241a17;
  margin: 0 0 24px;
  text-align: center;
  line-height: 1.05;
  letter-spacing: -0.02em;

  @media (max-width: 640px) {
    font-size: 28px;
  }
`;

export default function ProductsPage() {
  return (
    <div css={containerStyles}>
      <h1 css={headingStyles}>Products</h1>
    </div>
  );
}
